import i18next from 'i18next';
import { colors } from '../style/colors';
import { EventType } from '../types';

export const getEventLabel = (type: EventType) => {
  const eventLabel = {
    [EventType.WEBINAR]: i18next.t('v2.global.label_webinar'),
    [EventType.ONE_ON_ONE]: i18next.t('v2.global.label_1-1Call'),
    [EventType.WORKSHOP]: i18next.t('v2.global.label_workshop'),
    [EventType.EXERCISE]: i18next.t('v2.global.label_exercise'),
    [EventType.EXCHANGE_GROUP]: i18next.t('v2.global.label_exchangeGroup'),
    [EventType.MEDITATION]: i18next.t('v2.global.label_meditation'),
    default: i18next.t('v2.global.chip_label_fallback_event'),
  };

  return eventLabel[type] ?? eventLabel.default;
};

export const eventColors = {
  default: colors.gainsboro,
  WORKSHOP: colors.mediumBlue,
  WEBINAR: colors.darkSteelBlue,
  ONE_ON_ONE: colors.darkPurple,
  EXCHANGE_GROUP: colors.strongBlue,
  MEDITATION: colors.shinyBlue,
  EXERCISE: colors.shinyBlue,
};

export const getEventColor = ({ type }: { type: EventType }) =>
  eventColors[type] ?? eventColors.default;
